import { useLocation } from "wouter";
import { CheckCircle2, Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useWalletBalance } from "@/hooks/use-wallet";

export default function TopUpSuccess() {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === "ar";
  const [, navigate] = useLocation();
  const { data: walletData } = useWalletBalance();
  const balance = walletData?.balance ?? 0;
  const currency = walletData?.currency ?? t("services.currency");

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-background px-4"
      dir={isRtl ? "rtl" : "ltr"}
    >
      <div className="text-center max-w-md w-full">
        {/* Success icon */}
        <div className="w-24 h-24 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center mx-auto mb-6">
          <CheckCircle2 className="w-14 h-14 text-green-500" />
        </div>

        <h1 className="text-2xl font-bold mb-2">
          {t("walletPage.topUpSuccess")}
        </h1>
        <p className="text-muted-foreground mb-6">
          {t("walletPage.topUpSuccessDesc")}
        </p>

        {/* New balance card */}
        <div className="bg-primary text-primary-foreground rounded-2xl p-6 mb-6">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Wallet className="w-5 h-5 opacity-80" />
            <p className="text-sm opacity-90">{t("walletPage.balance")}</p>
          </div>
          <p className="text-4xl font-bold">
            {balance.toFixed(3)} <span className="text-2xl font-medium opacity-90">{currency}</span>
          </p>
        </div>

        <div className="space-y-2">
          <Button
            className="w-full h-12"
            onClick={() => navigate("/wallet")}
          >
            {t("walletPage.goToWallet")}
          </Button>
          <Button
            variant="ghost"
            className="w-full"
            onClick={() => navigate("/")}
          >
            {t("giftPage.backHome")}
          </Button>
        </div>
      </div>
    </div>
  );
}
